import RestService from "~/core/services/rest.service";
import superAdministrationService from "~/modules/superAdministration/services/superAdministration.service";
import type { FetchUserProfileParameters } from "~/modules/user/models/FetchUserProfileParameters.interface";
import type { UserProfile } from "~/modules/user/models/UserProfile.interface";
import type { UserProfileV2 } from "~/modules/user/models/UserProfileV2.interface";

class UserProfileSuperAdministrationService extends RestService {
  /**
   * Retrieve userProfiles
   */
  getUserProfiles({
    searchParams,
  }: FetchUserProfileParameters): Promise<UserProfileV2[]> {
    const params = {
      filter: searchParams,
    };

    return this.$apiV2.get(this.getSuperAdministrationProfilesPath(), {
      params,
    });
  }

  /**
   * Get a userProfile by code
   * @param profileCode
   */
  getUserProfileByCode(profileCode: string): Promise<UserProfile> {
    return this.$api.get(
      `${this.getSuperAdministrationProfilesPath()}/${profileCode}`,
    );
  }

  /**
   * Get multiple profiles
   * @param codes
   */
  getUserProfilesByCodes(codes: string[]): Promise<UserProfile[]> {
    const data = {
      codes,
    };
    const config = {
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
    };
    return this.$api.post(
      `${this.getSuperAdministrationProfilesPath()}/getUserProfilesByCodes`,
      data,
      config,
    );
  }

  /**
   * Create a userProfile
   * @param userProfile
   */
  createUserProfile(userProfile: UserProfile) {
    return this.$api.post(`${this.getSuperAdministrationProfilesPath()}`, {
      userProfile,
    });
  }

  /**
   * Update a userProfile
   * @param profileCode
   * @param userProfile
   */
  updateUserProfile(
    profileCode: string,
    userProfile: UserProfile,
  ): Promise<any> {
    return this.$api.put(
      `${this.getSuperAdministrationProfilesPath()}/${profileCode}`,
      { userProfile },
    );
  }

  /**
   * Remove a userProfile
   * @param profileCode
   */
  deleteUserProfile(profileCode: string): Promise<void> {
    return this.$api.delete(
      `${this.getSuperAdministrationProfilesPath()}/${profileCode}`,
    );
  }

  private getSuperAdministrationProfilesPath() {
    return `${superAdministrationService.getSuperAdministrationPath()}/profiles`;
  }
}

export default new UserProfileSuperAdministrationService();
